import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';

export interface IntegrationType {
  integrationTypeID: number;
  typeCode: string;
  typeName: string;
  description?: string;
  adapterClassName: string;
  category: string;
  isActive: boolean;
  requiresAuthentication: boolean;
  supportsBatchProcessing: boolean;
  supportsScheduling: boolean;
  hasPreconfiguredMapping: boolean; // True for adapters with hardcoded mappings (e.g., NXT GraphQL adapters)
  configSchema?: string;
  createdDate: Date;
  modifiedDate?: Date;
  activeIntegrationCount: number;
}

export interface SaveIntegrationTypeRequest {
  integrationTypeID?: number;
  typeCode: string;
  typeName: string;
  description?: string;
  adapterClassName: string;
  category: string;
  isActive: boolean;
  requiresAuthentication: boolean;
  supportsBatchProcessing: boolean;
  supportsScheduling: boolean;
  hasPreconfiguredMapping: boolean;
  configSchema?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SystemIntegrationTypeService {
  private readonly apiUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiUrl = `${this.configService.get('apiBaseUrl')}/SystemIntegrationType`;
  }

  getAllIntegrationTypes(activeOnly?: boolean): Observable<any> {
    const params = activeOnly !== undefined ? `?activeOnly=${activeOnly}` : '';
    return this.http.get<any>(`${this.apiUrl}${params}`).pipe(
      map((response: any) => response)
    );
  }

  getIntegrationTypeById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`).pipe(
      map((response: any) => response)
    );
  }

  createIntegrationType(request: SaveIntegrationTypeRequest): Observable<any> {
    return this.http.post<any>(this.apiUrl, request).pipe(
      map((response: any) => response)
    );
  }

  updateIntegrationType(id: number, request: SaveIntegrationTypeRequest): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, request).pipe(
      map((response: any) => response)
    );
  }

  deleteIntegrationType(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`).pipe(
      map((response: any) => response)
    );
  }

  getUsageCount(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}/UsageCount`).pipe(
      map((response: any) => response)
    );
  }
}
